/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureAnnotationItem } from './CaptureAnnotationItem';
import {
    CaptureAnnotationItemFromJSON,
    CaptureAnnotationItemFromJSONTyped,
    CaptureAnnotationItemToJSON,
    CaptureAnnotationItemToJSONTyped,
} from './CaptureAnnotationItem';

/**
 * 
 * @export
 * @interface AnnotateCapturesRequest
 */
export interface AnnotateCapturesRequest {
    /**
     * 
     */
    annotations: Array<CaptureAnnotationItem>;
}

/**
 * Check if a given object implements the AnnotateCapturesRequest interface.
 */
export function instanceOfAnnotateCapturesRequest(value: object): value is AnnotateCapturesRequest {
    if (!('annotations' in value) || value['annotations'] === undefined) return false;
    return true;
}

export function AnnotateCapturesRequestFromJSON(json: any): AnnotateCapturesRequest {
    return AnnotateCapturesRequestFromJSONTyped(json, false);
}

export function AnnotateCapturesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnnotateCapturesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'annotations': ((json['annotations'] as Array<any>).map(CaptureAnnotationItemFromJSON)),
    };
}

export function AnnotateCapturesRequestToJSON(json: any): AnnotateCapturesRequest {
    return AnnotateCapturesRequestToJSONTyped(json, false);
}

export function AnnotateCapturesRequestToJSONTyped(value?: AnnotateCapturesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'annotations': ((value['annotations'] as Array<any>).map(CaptureAnnotationItemToJSON)),
    };
}

